import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MessageCircleQuestion, Bug, Lightbulb } from 'lucide-react';
import { BugReportDialog } from './BugReportDialog';
import { ChangeRequestDialog } from './ChangeRequestDialog';

export function FeedbackButton() {
  const [bugDialogOpen, setBugDialogOpen] = useState(false);
  const [changeDialogOpen, setChangeDialogOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            variant="secondary"
            className="fixed bottom-6 right-6 h-11 w-11 rounded-full shadow-lg z-50 bg-red-500 hover:bg-red-600 text-white"
          >
            <MessageCircleQuestion className="h-5 w-5" />
            <span className="sr-only">Open feedback menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="top" className="mb-2">
          <DropdownMenuItem onClick={() => setBugDialogOpen(true)}>
            <Bug className="h-4 w-4 mr-2" />
            Report a Bug
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setChangeDialogOpen(true)}>
            <Lightbulb className="h-4 w-4 mr-2" />
            Suggest a Change
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <BugReportDialog open={bugDialogOpen} onOpenChange={setBugDialogOpen} />
      <ChangeRequestDialog open={changeDialogOpen} onOpenChange={setChangeDialogOpen} />
    </>
  );
}
